module.exports = __webpack_public_path__ + "img/copy2.49f8193b.svg";